module.exports = __webpack_public_path__ + "static/sjova-1-2a994d122042f0cc45ebcdf91d0c9494.jpg";